"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getLogMessage;

var _fluxStandardAction = require("flux-standard-action");

var _get = _interopRequireDefault(require("lodash/get"));

var _invariant = _interopRequireDefault(require("invariant"));

var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));

var _isApiError = _interopRequireDefault(require("./is-api-error"));

var _formatActionApiErrorMessages = _interopRequireDefault(require("./format-action-api-error-messages"));

function getActionMessage(action) {
  var message;
  var rollbarActionMessage = (0, _get.default)(action, 'rollbar.message');

  if (rollbarActionMessage) {
    message = rollbarActionMessage;
  } else if ((0, _fluxStandardAction.isFSA)(action) && (0, _fluxStandardAction.isError)(action)) {
    var fsaErrorMessage = (0, _get.default)(action, 'payload.message');

    if (fsaErrorMessage) {
      message = fsaErrorMessage;
    }
  }

  return message;
}
/**
 * Returns the log message to be sent to rollbar. If the payload of the provided action is an error,
 * the message will be created with the `formatActionApiErrorMessages` function. If the
 * `rollbar.message` field on an action is defined, that message will be used otherwise. If no other
 * message can be determined the `action.type` will be used as the message.
 *
 * @param {Object} action - a redux action
 */


function getLogMessage(action) {
  (0, _invariant.default)((0, _isPlainObject.default)(action), 'An action must be provided');
  var message = getActionMessage(action);

  if ((0, _isApiError.default)(action)) {
    return (0, _formatActionApiErrorMessages.default)(action);
  }

  if (message) {
    return message;
  }

  return action.type;
}